var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ik-data-table',{attrs:{"model":_vm.model,"required-date-value":_vm.$parent.dateRange,"use-action":false,"use-default-action":false,"entity-name":"分类统计报表","icon":"mdi-cards"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }